import { Injectable } from '@angular/core';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import { MdbModalWrapperService } from 'app/core/services/mdb-modal-wrapper.service';
import { AuctionUpdateBidderModalComponent } from '../../modals/auction-update-bidder-modal/auction-update-bidder-modal.component';

@Injectable({
  providedIn: 'root'
})

export class ModalAuctionUpdateEmailService {

  public modalRef: MdbModalRef<any> | null = null;

  constructor(
    private modalService: MdbModalWrapperService,
  ) { }

  open(data) {
    if(this.modalRef) {
      return this.modalRef;
    }

    this.modalRef = this.modalService.open(AuctionUpdateBidderModalComponent, {
      ignoreBackdropClick: false,
      containerClass:'mdb-modal-backdrop-paybee modal fade show',
      modalClass:'modal-dialog',
      data: {data}
    });    

    return this.modalRef;
  }

  close() {
    if (this.modalRef) {
      this.modalRef.close();
      this.modalRef = null;
    }
  }
}